export default __webpack_public_path__ + "static/media/08-bose.fc1caed8.mp4";